<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
		:config="config"
  >
		<template #Total="{params,visible}">
			<div style="text-align: right;" v-if="!params.write">
				CNY: <span style="color:red">{{params.total}}</span>
			</div>
		</template>
  </cTable>
</template>

<script>
import {
  getclaimFee,
  getclaimFeeDetail,
  updateClaimFee,
  delClaimFee,
  confirmClaimFee,
  getExchangeRate,
  writeOff,
  removeClaimFee,
  addClaimFee,
  billDetail,
  writeOffDetail,
	batchDelete,
	setAmount,
	addCost,
	exportAmount,
	batchWriteOff,
	billExport,
	getBank,
	extract,
	costDetail,
} from "@/api/cost/bill";
import { getAllClient } from "@/api/user/client";
import { getCompanies } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import { getAgent } from "@/api/tracker/agent";
import copyClick from "@/utils/copyClick";
import cTable from "@/base/common/index";
import { getAllService } from "@/api/user/internal";
import { getSubjectCost } from "@/api/tracker/cost_page";
import { getCurrency } from "@/api/finance/currency";
export default {
  name: "cost_bill",
  components: {
    cTable,
  },
	activated() {
		if(this.$store.state.user.pageUrl){
		this.config.isGetList = true;
	  this.$refs["table"].$refs[
	    "header"
	  ].searchForm.keywords = this.$store.state.user.pageUrl;
	  this.$store.state.user.pageUrl = "";
		this.$nextTick(()=>{
			this.$refs["table"].getList();
		})
		}
	},
	mounted() {
		if(!this.$store.state.user.pageUrl){
			this.$refs["table"].getList();
		}
	},
  data() {
    let optionsLabel = ["transfer_order", "self_mention", "monthly_fee"];
    let options = [
      { label: optionsLabel[0], value: 1 },
      { label: optionsLabel[1], value: 2 },
      { label: optionsLabel[2], value: 3 },
    ];
    return {
			total:0,
			transformTotal:0,
			config:{
				isGetList:true
			},
      detailList: [],
      methods: {
        list: getclaimFee,
        billDetail,
        writeOffDetail,
        getclaimFeeDetail,
        getAllClient,
        getCompanies,
        updateClaimFee,
        delClaimFee,
        confirmClaimFee,
        getExchangeRate,
        writeOff,
        removeClaimFee,
        addClaimFee,
				batchDelete,
				setAmount,
				addCost,
				batchWriteOff,
				billExport,
				getBank,
				extract,
				costDetail,
      },
      modals: {
        showDetails: {
					contentBottom:'Total',
          type: "add",
          methods: {
            ok: ({ row, close }) => {
              let page = this.$refs["table"];
							let data = new FormData();
							let that = this.$refs["table"].getModal("showDetails");
							if(row.batch){
								row.ids.forEach(t=>{
									data.append("ids[]", t);
								})
							}else{
								let ids = this.$refs["table"]
								  .getModal("showDetails")
								  .selectAll.map((t) => t.id);
								if (!ids.length)
								  return this.$Message.error({
								    content: this.$t("select_fee_detail"),
								  });
								data.append("ids", ids);
							}

              data.append(
                "file",
                row.files && row.files[0] && row.files[0].file
              ); // 文件对象
              data.append("bank_id", row.bank_id);
              data.append("pay_time", row.pay_time);
              this.$refs["table"]
                .handleRequestMethods(
                  row.batch?'batchWriteOff':"writeOff",
                  row.batch?data:{ id: row.row.id, data },
                  false,
                  true
                )
                .then((res) => {
                  this.$Message.success({
                    content: res.msg,
                    background: true,
                  });
                  page.getList();
                  close();
                });
            },
            cancel:()=> {
              // console.log("1123");
							this.total = 0
							this.transformTotal = 0
							let table = this.$refs['table']
							let modal = table.getModal('showDetails')
							if(!modal.params.batch)table.getList();
            },

						checkTable:({ row }) => {
						  let amount = 0;
						  let amount2 = 0;
						  row.map((item) => {
						    amount += parseFloat(item.amount);
						    amount2 += parseFloat(item.to_amount);
						    return;
						  });
						  this.total = amount.toFixed(2)
						  this.transformTotal = amount2.toFixed(2)
						  this.$forceUpdate();
						},
          },
          header: {
            show: () => {
              return !this.$refs["table"].getModal("showDetails").params.batch && !this.$refs["table"].getModal("showDetails").params.write;
            },
            copy: true,
            btns: [
              {
                name: this.$t("export")+this.$t('def')+this.$t('Dimension'),
                fnName: "exportFun",
                bind: {
                  type: "primary",
                  style: "margin-right: 10px",
                },
              	type:1
              },
              {
                name: this.$t("export")+this.$t('extract')+this.$t('Dimension'),
                fnName: "exportFun",
                bind: {
                  type: "primary",
                  style: "margin-right: 10px",
                },
              	type:2
              },
              {
                name: this.$t("MoveOut"),
                fnName: "moveFun",
                bind: {
									style: "margin-right: 10px",
                  type: "success",
                },
                disabled() {
                  return !this.selectAll.length;
                },
                show() {
                  return this.pageConfig.data.status != 9;
                },
                id: 994,
              },
							{
							  name: this.$t("addTo") + this.$t('cost_bill'),
							  fnName: "addCost",
							  bind: {
									style: "margin-right: 10px",
							    type: "success",
							  },
							  // id: 994,
							},
							{
							  name: this.$t("download") + this.$t('CorrectDeliveryCost') + this.$t('template'),
							  fnName: "down",
							  bind: {
									style: "margin-right: 10px",
							    type: "success",
							  },
							  // id: 994,
							},
            ],
            methods: {
							down(){
								window.open(this.$globalUrl+'/doc/zh-CN/send_cost.xlsx')
							},
							addCost(){
								this.$page.getModal('addCost').open({id:this.pageConfig.data.id})
							},
              copy({ row }) {
                copyClick.copyToClipboard(row.bill_number, this);
              },
              moveFun({ row }) {
                this.$Modal.confirm({
                  title:
                    this.$t("MoveOut") +
                    this.$t("claim") +
                    this.$t("Odd_Numbers"),
                  width: 300,
                  content: this.$t("titleModal"),
                  onOk: () => {
                    let data = {
                      pid: this.pageConfig.data.id,
                      ids: this.selectAll.map((item) => item.id),
                    };
                    this.$page
                      .handleRequestMethods("removeClaimFee", data, true, true)
                      .then((res) => {
                        this.getList();
                      });
                  },
                });
              },
              exportFun({ row,field }) {
                this.$page
                  .handleRequestMethods(
                    "billExport",
										{
											type:field.type,
											id:this.pageConfig.data.id
										},
                    true,
                    true
                  )
                  .then((res) => {
                    window.open(this.$globalUrl + res.payload.src);
                  });
              },
            },
          },
          config: {
            listFn: "getclaimFeeDetail",
						width: 80,
            modalBind: {
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {
							labelWidth:120,
						},
          },
          footer: {
            show: () => {
              return this.$refs["table"].getModal("showDetails").params.write;
            },
          },
          rules: {
            bank_id: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "change",
								type:'number'
              },
            ],
            pay_time: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "change",
              },
            ],
          },
          grid: [{ bank_id: 24 }, { pay_time: 24 }, { files: 24 }],
          fields: [
            {
              name: () => this.$t("bank_name"),
              key: "bank_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("bank_name");
              },
							options:[],
							methods:{
								list({field}){
									this.$page.handleRequestMethods('getBank').then(res=>{
										field.options = res.payload
									})
								}
							}
            },
            {
              name: () => this.$t("pay_time"),
              key: "pay_time",
              placeholder() {
                return this.$t("enter") + this.$t("pay_time");
              },
              component: "DatePicker",
              bind: {
                type: "datetime",

                style: {
                  width: "175px",
                },
              },
            },
            {
              key: "files",
              component: "Upload",
              name: () => this.$t("pay_picture"),
              bind: {
                type: "drag",
                accept: ".jpg,.png,.webp,.jpeg",
                multiple: true,
                fileName: "files",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let data = {
                    file: file,
                    filename: file.name,
                  };
                  this.$refs["table"]
                    .getModal("showDetails")
                    .setFormData({ files: [data] });
                  return false;
                },
              },
            },
          ],
          table: {
            config: {
              height: 750,
            },
						show() {
						  return !this.params.batch;
						},
            footer: {
              show() {
                return this.getModal("showDetails").config.hideForm;
              },
							render: (h, r) => {
								if(this.$refs['table'].getModal("showDetails").params.batch)return
								return h(
									"div",
									{ style: "text-align:right" },
									[h("span", { style: "margin-left:10px" }, [
										h("span", {}, this.$t('total_amount')+':'),
										h("span", { style: "color:red" }, this.total),
									]),
									h("span", { style: "margin-left:10px" }, [
										h("span", {}, this.$t('to')+this.$t('total_amount')+':'),
										h("span", { style: "color:red" }, this.transformTotal),
									])]
								);
							},
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                fixed: "left",
                width: 60,
              },
              {
                name: () => this.$t("classExpense"),
                key: "expense_item",
                width: 100,
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                minWidth: 100,
              },
              {
                name: () => this.$t("currency_t"),
                key: "currency",
                minWidth: 80,
              },
              {
                name: () => this.$t("to") + this.$t("rate"),
                key: "to_rate",
                minWidth: 80,
              },
              {
                name: () => this.$t("to") + this.$t("currency_t"),
                key: "to_currency",
                minWidth: 80,
              },
              {
                name: () => this.$t("to") + this.$t("reChAmount"),
                key: "to_amount",
                minWidth: 100,
              },
              {
                type: "btns",
                width: 200,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("detail"),
                    type: "detail",
                    fnName: "detail",
                    bind: {
                      type: "warning",
                    },
                    id: 1024,
                  },
									{
									  name: () => this.$t("modify"),
									  type: "modify",
									  fnName: "modify",
									  bind: {
									    type: "primary",
									  },
									  id: 1201,
									},
									{
										name: this.$t('CorrectDeliveryCost') + this.$t("import"),
										fnName: "importAmount",
										bind: {
											type: "primary",
										},
										show({row}){
											return row.is_send
										}
										// id: 994,
									},
                ],
                methods: {
									importAmount({row}){
										let el = document.createElement('input')
										el.type="file"
										el.click()
										el.addEventListener('input',(e)=>{
											let formData = new FormData()
											formData.append('file',el.files[0])
											exportAmount(formData,row.id).then(res=>{
												if(res.data.status){
													this.$Message["success"]({
														background: true,
														content: res.data.msg,
													});
													this.$page.getModal("showDetails").getList()
												}
											})
										})
									},
									modify({row}){
										this.getModal('setAmount').open({amount:row.amount,id:row.id})
									},
                  detail({ row }) {
                    console.log(this);
                    this.getModal("showDetails2").setTitle(this.$t("detail"));
                    this.getModal("showDetails2").open({ row }, function () {
                      let data = {
                        id: row.id,
                        status: row.status,
                      };
                      this.pageConfig.data = data;
                      this.getList(data);
                    });
                  },
                },
              },
            ],
          },
        },
        showDetails2: {
          config: {
            listFn: "billDetail",
            modalBind: {
              width: 80,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: true,
            },
            fields: [
              {
              	name: () => this.$t("mawb"),
              	key:'extract',
              	align: "center",
              	minWidth: 130
              },
              {
                name: () => this.$t("BillingNumber"),
                key: "number",
                align: "center",
                minWidth: 150
              },
              {
                name: () => this.$t("agentName"),
                key: "agent_name",
                align: "center",
                minWidth: 120
              },
              {
                name: () => this.$t("costCategories"),
                key: "classify_id",
                align: "center",
                minWidth: 120
              },
              {
                name: () => this.$t("costSuject"),
                key: "expense_item",
                align: "center",
                minWidth: 120
              },
              {
                name: () => this.$t("currency_t"),
                key: "currency",
                align: "center",
                minWidth: 100
              },

              {
                name: () => this.$t("quantity1"),
                key: "charging_value",
                align: "center",
                minWidth: 120
              },
              {
                name: () => this.$t("doublePrice"),
                key: "price",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("finalCost") + this.$t("reChAmount"),
                key: "amount",
                align: "center",
                minWidth: 120
              },
              {
                name: () => this.$t("createUser"),
                key: "create_name",
                align: "center",
                minWidth: 100
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                align: "center",
                minWidth: 160
              },
            ],
          },
        },
        writeOffDetail: {
          config: {
            modalBind: {
              width: 80,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: () => false,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                fixed: "left",
                width: 60,
              },
              {
                name: () => this.$t("bank_name"),
                key: "bank_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("pay_time"),
                key: "pay_time",
                width: 100,
              },
              {
                name: () => this.$t("pay_picture"),
                key: "src",
                minWidth: 100,
                component: "Button",
                bind: {
                  size: "small",
                  type: "primary",
                },
                methods: {
                  click({ row }) {
                    window.open(this.$globalUrl + row.src);
                  },
                  render() {
                    return this.$t("show1");
                  },
                },
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                minWidth: 80,
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                minWidth: 130,
              },
              {
                type: "btns",
                width: 200,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("detail"),
                    type: "detail",
                    fnName: "detail",
                    bind: {
                      type: "warning",
                    },
                    id: 1024,
                  },
                ],
                methods: {
                  detail({ row }) {
                    console.log(this);
                    this.getModal("writeOffDetail2").setTitle(
                      this.$t("detail")
                    );
                    this.getModal("writeOffDetail2").open({ row }, function () {
                      this.list = row.child;
                    });
                  },
                },
              },
            ],
          },
        },
        writeOffDetail2: {
          config: {
            modalBind: {
              width: 80,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: () => false,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                fixed: "left",
                width: 60,
              },
              {
                name: () => this.$t("classExpense"),
                key: "expense_item",
                minWidth: 100,
              },
              {
                name: () => this.$t("currency_t"),
                key: "currency",
                width: 100,
              },
              {
                name: () => this.$t("reChAmount"),
                key: "amount",
                minWidth: 100,
              },
              {
                name: () => this.$t("to") + this.$t("rate"),
                key: "to_rate",
                minWidth: 80,
              },
              {
                name: () => this.$t("to_rmb"),
                key: "to_amount",
                minWidth: 80,
              },
            ],
          },
        },
				setAmount: {
					type:'add',
				  methods: {
				    ok({ row, close }) {
							let detailModal = this.$page.getModal('showDetails')
							this.$page.getModal('showDetails').getList({
								id:detailModal.params.row.id,
								status:detailModal.params.row.status,
							})
				      this.$page
				        .handleRequestMethods("setAmount", row, true, true)
				        .then((res) => {
				          this.$page.getList();
				          close();
				        });
				    },
				  },
				  config: {
						title:this.$t("modify"),
				    modalBind: {
				      width: 600,
				      draggable: true,
				    },
				    formBind: {
				      labelWidth: 100,
				    },
				    rowBind: {
				      gutter: 16,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    rules: {
				      amount: [
				        {
				          required: true,
				          trigger: "change",
									type: 'number'
				        },
				      ],
							currency: [
							  {
							    required: true,
							    trigger: "change",
							  },
							],
							rate_time: [
							  {
							    required: true,
							    trigger: "change",
									type:'date'
							  },
							],
				    },
				  },
				  grid: [{ amount: 24 }, { currency: 24 }, { rate_time: 24 }],
				  fields: [
				    {
				      name: () => this.$t("reChAmount"),
				      key: "amount",
				      component: "Input",
							bind:{
								number:true,
							},
				      placeholder() {
				        return this.$t("enter") + this.$t("reChAmount");
				      },
				    },
				    {
				      name: () => this.$t("currency_t"),
				      key: "currency",
				      component: "Select",
				      config: {
				        label: "code",
				        value: "code",
				      },
				      options: [],
				      methods: {
				        async list({ field, row }) {
				          field.options = (
				            await getCurrency({ pageSize: 9999 })
				          ).data.payload.rows;
				          this.$forceUpdate();
				        },
				      },
				      placeholder() {
				        return this.$t("select") + this.$t("currency_t");
				      },
				    },
						{
							key: "rate_time",
							component: "DatePicker",
							name:this.$t("rate") +this.$t("date"),
							placeholder() {
							  return (
							    this.$t("select") +
							    this.$t("rate") +
							    this.$t("date")
							  );
							},
							bind: {
							  type: "month",
							  options: {
							    disabledDate(time) {
							      return time.getTime() > Date.now();
							    },
							  },
							  style: {
							    width: "175px",
							  },
							},
							methods: {
							  format({value}) {
							    return this.format.monthFormat(value) || "";
							  },
							},
						}
				  ],
				},
				addCost: {
					type:'add',
				  methods: {
				    ok({ row, close }) {
				      this.$page
				        .handleRequestMethods("addCost", row, true, true)
				        .then((res) => {
				          this.$page.getModal('showDetails').getList()
				          close();
				        });
				    },
				  },
				  config: {
				    modalBind: {
				      width: 600,
				      draggable: true,
				    },
				    formBind: {
				      labelWidth: 100,
				    },
				    rowBind: {
				      gutter: 16,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    rules: {
				      expense_item: [
				        {
				          required: true,
				          trigger: "change",
									type: 'array'
				        },
				      ],
							currency: [
							  {
							    required: true,
							    trigger: "blur",
							  },
							],
							amount: [
							  {
							    required: true,
							    trigger: "blur",
									type:'number',
							  },
							],

				    },
				  },
				  grid: [{ expense_item: 24 }, { currency: 24 },{ amount: 24 },{ remarks: 24 }],
				  fields: [
				    {
				      name: () => this.$t('finalCost')+this.$t("reChAmount"),
				      key: "amount",
				      component: "Input",
							bind:{
								number:true,
							},
				      placeholder() {
				        return this.$t("enter") + this.$t("reChAmount");
				      },
				    },
						{
						  name: () => this.$t("expense"),
						  key: "expense_item",
						  component: "Cascader",
						  placeholder() {
						    return this.$t("select") + this.$t("expense");
						  },
						  options: [],
						  default: [],
						  methods: {
						    async list({ field, row }) {
						      field.options = (
						        await getSubjectCost({ pid: 0 })
						      ).data.payload;
						      this.$forceUpdate();
						    },
						    async loadData({ item, callback }) {
						      console.log(arguments);
						      item.loading = true;
						      item.children = (
						        await getSubjectCost({ pid: item.value })
						      ).data.payload;
						      item.loading = false;
						      callback();
						    },
						  },
						},
						{
						  name: () => this.$t('finalCost')+this.$t("currency_t"),
						  key: "currency",
						  component: "Select",
						  placeholder() {
						    return (
						      this.$t("select") +
						      this.$t("calculation") +
						      this.$t("currency_t")
						    );
						  },
						  config: {
						    label: "code",
						    value: "code",
						  },
						  options: [],
						  methods: {
						    async list({ field, row }) {
						      field.options = (
						        await getCurrency({ pageSize: 9999 })
						      ).data.payload.rows;
						      this.$forceUpdate();
						    },
						  },
						},
						{
						  name: () => this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  bind: {
						    type: "textarea",
						    autosize: { minRows: 2 },
						  },
						  placeholder() {
						    return this.$t("enter") + this.$t("Remarks");
						  },
						},
				  ],
				},
        updateFee: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateClaimFee", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bill_name: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ bill_name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("bill_name"),
              key: "bill_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bill_name");
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
        rate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("getExchangeRate", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              rate: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ usd_to_cny: 24 }, { hkd_to_cny: 24 }, { sar_to_cny: 24 }],
          fields: [
            {
              name: () => this.$t("UsdToRMB"),
              key: "usd_to_cny",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("UsdToRMB");
              },
              bind: {
                min: 0,
                max: 99999,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("HkdToRMB"),
              key: "hkd_to_cny",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("HkdToRMB");
              },
              bind: {
                min: 0,
                max: 99999,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("SarToRMB"),
              key: "sar_to_cny",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("SarToRMB");
              },
              bind: {
                min: 0,
                max: 99999,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addClaimFee", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
          ],
        },
				detail:{
					footer:{
						show:()=>false
					},
					header: {
					  show: () => true,
					  copy: true,
					  btns: [
					    {
					      name: this.$t("export")+this.$t('def')+this.$t('Dimension'),
					      fnName: "exportFun",
					      bind: {
					        type: "primary",
					        style: "margin-right: 10px",
					      },
								type:1
					    },
							{
							  name: this.$t("export")+this.$t('extract')+this.$t('Dimension'),
							  fnName: "exportFun",
							  bind: {
							    type: "primary",
							    style: "margin-right: 10px",
							  },
								type:2
							},
					  ],
					  methods: {
					    exportFun({ row,field }) {
					      this.$page
					        .handleRequestMethods(
					          "extract",
					          {
											id:this.pageConfig.data.id,
											type:field.type,
											export:1
										},
					          true,
					          true
					        )
					        .then((res) => {
					          window.open(this.$globalUrl + res.payload.src);
					        });
					    },
					  },
					},
					config: {
						listFn:'extract',
						width: 1000,
					  modalBind: {
					    transfer: true,
					    draggable: true,
					    sticky: true,
					    "reset-drag-position": true,
					  },
					},
					table: {
					  config: {
					    height: 600,
					  },
						footer:()=>true,
					  fields: [
					    {
					      type: "checkbox",
					      align: "center",
					      fixed: "left",
					      width: 60,
					    },
					    {
					      name: () => this.$t("BillingNumber"),
					      key: "number",
					      minWidth: 100,
					    },
					    {
					      name: () => this.$t("currency_t"),
					      key: "currency",
					      width: 80,
					    },
					    {
					      name: () => this.$t("reChAmount"),
					      key: "amount",
					      minWidth: 100,
					    },
							{
							  name: () => this.$t("type"),
							  key: "type_txt",
							  minWidth: 100,
							},
              {
                name: () => this.$t("CNY") + this.$t("reChAmount"),
                key: "cny_amount",
                minWidth: 100,
              },
					    {
					      type: "btns",
					      width: 200,
					      name: () => this.$t("operation"),
					      fixed: "right",
					      list: [
					        {
					          name: () => this.$t("detail"),
					          type: "detail",
					          fnName: "detail",
					          bind: {
					            type: "warning",
					          },
										disabled({row}){
											return row.send_type > 0
										}
					        },
					      ],
					      methods: {
					        detail({ row }) {
					          console.log(this);
					          this.getModal("costDetail").setTitle(this.$t('cost_t')+this.$t("detail"));
					          this.getModal("costDetail").open({ row }, function () {
					            this.$page.handleRequestMethods('costDetail',{
												id:this.$page.getModal("detail").params.row.id,
												extract_id:row.extract_id,
												packing_id:row.packing_id,
												type:row.type
											}).then(res=>{
												this.list = res.payload
											})
					          });
					        },
					      },
					    },
					  ],
					},
				},
				costDetail:{
					footer:{
						show:()=>false
					},
					config: {
						width: 800,
					  modalBind: {
					    transfer: true,
					    draggable: true,
					    sticky: true,
					    "reset-drag-position": true,
					  },
					},
					table: {
					  config: {
					    height: 600,
					  },
					  fields: [
					    {
					      type: "checkbox",
					      align: "center",
					      fixed: "left",
					      width: 60,
					    },
					    {
					      name: () => this.$t("costCategories"),
					      key: "classify_id",
					      width: 100,
					    },
					    {
					      name: () => this.$t("costSuject"),
					      key: "expense_item",
					      minWidth: 80,
					    },
					    {
					      name: () => this.$t("billingCurrency"),
					      key: "currency",
					      minWidth: 100,
					    },
							{
							  name: () => this.$t("quantity1"),
							  key: "charge",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("billing_price"),
							  key: "price",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("total_amount"),
							  key: "amount",
							  minWidth: 100,
							},
					  ],
					},
				}
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["BILL_TIME_TYPE"])).data
                  .payload["BILL_TIME_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("bill1") + this.$t("tip");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["BILL_STATUS_TYPE"])).data
                  .payload["BILL_STATUS_TYPE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "agent_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "id" },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getAgent()).data.payload.rows;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "create_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("operate");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getAllService()).data.payload[6];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          // {
          //   key: "type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("extractType");
          //   },
          //   component: "Select",
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["COST_BILL_TYPE_SELECT"])).data
          //         .payload["COST_BILL_TYPE_SELECT"];
          //       field.options = res;
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["COST_BILL_KEYWORDS"])).data
                  .payload["COST_BILL_KEYWORDS"];
                field.options = res;
                searchForm['keywordsType'] = res[0].value
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
						{
						  name: () => this.$t("delete"),
						  type: "delete",
						  fnName: "delete",
							bind: {
							  type: "error",
							},
							disabled() {
							  return !this.selectAll.length;
							},
							id:1190
						},
						{
						  name: () => this.$t("batch")+this.$t('writeOff'),
						  type: "writeOff",
						  fnName: "writeOff",
							bind: {
							  type: "primary",
							},
							disabled() {
							  return !this.selectAll.length;
							},
							id:1248
						},
          ],
          methods: {
						writeOff(){
							let ids = this.selectAll.map(t=>t.id)
							this.getModal("showDetails").modal.type = "add";
							this.getModal("showDetails").config.hideForm = false;
							this.getModal("showDetails").modal.config.width = 600;
							this.getModal('showDetails').open({batch:1,write: true,ids},function(){
								this.setTitle(this.$t("batch")+this.$t('writeOff'))
							})
						},
						delete() {
							let ids = this.selectAll.map(t=>t.id)
							this.$Modal.confirm({
								title: this.$t("delete"),
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods("batchDelete", {ids}).then(
										(res) => {
											this.$Message["success"]({
												background: true,
												content: res.msg,
											});
											this.getList();
										}
									);
								},
							});
						},
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          copy: true,
          component: "Button",
          copy: true,
          fixed: "left",
          width: 190,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            async click({ row }) {
							console.log(this);
              this.$page
                .getModal("showDetails")
                .setTitle(this.$t("bill_number") + row.bill_number);
              this.$page.getModal("showDetails").config.hideForm = true;
							this.$page.getModal("showDetails").modal.config.width = 80;
              this.$page.getModal("showDetails").open({ total:0,row, write: false }, async function () {
                let data = {
                  id: row.id,
                  status: row.status,
                };
                this.table.config.height = 750;
                this.config.hideForm = true;
                this.hidePage = true;
                this.pageConfig.data = data;
                await this.getList(data);
								this.params.total = this.list.reduce((a,b)=>a +=b.to_amount,0)
              });
            },
          },
        },
        {
          name: () => this.$t("bill_name"),
          key: "bill_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          minWidth: 200,
        },
				{
				  name: () => this.$t('original')+ this.$t("reChAmount"),
				  key: "original_amount",
				  minWidth: 100,
				},
				{
				  name: () => this.$t('original')+ this.$t("currency_t"),
				  key: "original_currency",
				  minWidth: 100,
				},
        {
          name: () => this.$t("reChAmount"),
          key: "amount",
          minWidth: 100,
        },
        {
          name: () => this.$t("currency_t"),
          key: "currency",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          width: 150,
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          width: 150,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 100,
        },
        {
          name: () => this.$t("createUser"),
          key: "create_name",
          minWidth: 100,
        },

        {
          name: () => this.$t("bill_type"),
          key: "status_txt",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
						{
							name: () => this.$t("detail"),
							type: "detail",
							fnName: "detail",
							bind: {
								type: "primary",
							},
						},
            // {
            //   name: () => this.$t("addTo"),
            //   type: "add",
            //   fnName: "addFun",
            //   bind: {
            //     type: "success",
            //   },
            //   disabled({ row }) {
            //     return row.status == 9;
            //   },
            //   id: 993,
            // },
            {
              name: () => this.$t("confirm") + this.$t("bill1"),
              type: "confirm",
              fnName: "confirmFun",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              id: 1028,
            },
            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rateFun",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status == 9;
              },
              id: 1022,
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOffFun",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status != 4;
              },
              id: 1029,
            },
            {
              name: () => this.$t("writeOffDetail"),
              type: "writeOffDetail",
              fnName: "writeOffDetail",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status == 1;
              },
              id: 1029,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 1026,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.status == 9;
              },
              id: 1027,
            },
          ],
          methods: {
						detail({ row }) {
							console.log(this);
							this.getModal("detail").setTitle(this.$t("detail"));
							this.getModal("detail").open({ row }, function () {
								this.pageConfig.data.id = row.id
								this.getList()
							});
						},
            addFun({ row }) {
              let data = {
                id: row.id,
              };
              this.getModal("add").open(data, function () {
                this.setTitle(
                  this.$t("addTo") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              });
            },
            confirmFun({ row }) {
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("bill1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "confirmClaimFee",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            rateFun({ row }) {
              let data = {
                id: row.id,
                rate: row.to_rate,
                currency: row.to_currency,
                usd_to_cny: row.usd_to_cny || 0,
                hkd_to_cny: row.hkd_to_cny || 0,
                sar_to_cny: row.sar_to_cny || 0,
              };
              this.getModal("rate").open(data, function () {
                this.setTitle(this.$t("bill1") + this.$t("rate"));
              });
            },
            writeOffDetail({ row }) {
              this.getModal("writeOffDetail").open({ row }, function () {
                this.setTitle(this.$t("writeOffDetail"));
                this.$page
                  .handleRequestMethods("writeOffDetail", { id: row.id })
                  .then((res) => {
                    this.list = res.payload;
                  });
              });
            },
            writeOffFun({ row }) {

              this.getModal("showDetails").modal.type = "add";
              this.getModal("showDetails").config.hideForm = false;
							this.getModal("showDetails").modal.config.width = 80;
              this.getModal("showDetails").open(
                { row, write: true, type: "add" },
                function () {
                  let data = {
                    id: row.id,
                    status: row.status,
                    writeOff: 1,
                  };
                  this.files = [];
                  this.table.config.height = 350;
                  this.config.hideForm = false;
                  this.$page
                    .handleRequestMethods("getclaimFeeDetail", data)
                    .then((res) => {
                      console.log("list", res);
                      this.list = res.payload.rows;
                    });
                  this.setTitle(this.$t("writeOff"));
                }
              );
            },
            update({ row }) {
              this.getModal("updateFee").setTitle(
                this.$t("update") + this.$t("bill1")
              );
              this.getModal("updateFee").open({
                id: row.id,
                bill_name: row.bill_name,
                remarks: row.remarks,
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "delClaimFee",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
